module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C277"
  }, [_c('a', {
    attrs: {
      "id": "page_XXI"
    }
  }, [_vm._v("TIMELINE")])]), _c('a', {
    attrs: {
      "id": "page_XXI"
    }
  }), _c('div', {
    staticClass: "C705"
  }, [_c('a', {
    attrs: {
      "id": "page_XXI"
    }
  }, [_c('p', {
    staticClass: "C243"
  }, [_c('strong', [_vm._v("1863")])]), _vm._v(" "), _c('p', {
    staticClass: "C218"
  }, [_c('img', {
    staticClass: "Image151",
    attrs: {
      "alt": "",
      "src": "img/22_1.png",
      "width": "88%"
    }
  })])]), _c('p', {
    staticClass: "C219"
  }, [_c('a', {
    attrs: {
      "id": "page_XXI"
    }
  }), _c('a', {
    attrs: {
      "id": "page_XXII"
    }
  }, [_c('img', {
    staticClass: "Image151",
    attrs: {
      "alt": "",
      "src": "img/23_1.png",
      "width": "88%"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_XXII"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_XXII"
    }
  }), _c('div', {
    staticClass: "C705"
  }, [_c('a', {
    attrs: {
      "id": "page_XXII"
    }
  }, [_c('p', {
    staticClass: "C216"
  }, [_c('strong', [_vm._v("1864")])]), _vm._v(" "), _c('p', {
    staticClass: "C218"
  }, [_c('img', {
    staticClass: "Image151",
    attrs: {
      "alt": "",
      "src": "img/23_2.png"
    }
  })])]), _c('p', {
    staticClass: "C219"
  }, [_c('a', {
    attrs: {
      "id": "page_XXII"
    }
  }), _c('a', {
    attrs: {
      "id": "page_XXIII"
    }
  }, [_c('img', {
    staticClass: "Image151",
    attrs: {
      "alt": "",
      "src": "img/24_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_XXIII"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_XXIII"
    }
  }, [_c('div', {
    staticClass: "C705"
  }, [_c('p', {
    staticClass: "C216"
  }, [_c('strong', [_vm._v("1865")])]), _vm._v(" "), _c('p', {
    staticClass: "C218"
  }, [_c('img', {
    staticClass: "Image151",
    attrs: {
      "alt": "",
      "src": "img/24_2.png",
      "width": "99%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "C269"
  }, [_vm._v("*Thomas Ayres, "), _c('em', [_vm._v("Dark and Bloody Ground")]), _vm._v(", 263.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-440c51e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Timeline.vue
// module id = 84
// module chunks = 0